module.exports = {
	"articleTitle1": "Lab fire shuts down Chemistry building ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Chemistry Building",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/university-employee-dies-after-medical-distress-chemistry-building",
	"articleSnippet1": "Feb 8, 2017 ... The University of Michigan Chemistry building was evacuated and closed due to \na lab fire at approximately 9:30 a.m. Wednesday morning.",
	"articleSnippet2": "Sep 15, 2015 ... A University employee died inside the Chemistry Building early Tuesday, \naccording to the University's Division of Public Safety and Security.",
	"totalMisc": 1,
	"articleTitle2": "University employee dies after medical distress in Chemistry Building",
	"address": "930 N University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170208/msk.FEA_.FiretrucksChemStock.2.8.17.0013.JPG?itok=b8ihxLlI",
			"author": "Max Kuang",
			"caption": "A fire truck is parked outside the Chemistry building on Wednesday."
		}
	],
	"position": {
		"lat": 42.27805,
		"lng": -83.736624
	},
	"tips": [
		{
			"text": "There's some really nice natural light in the lobby, so it's pretty good place to study I'd say.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 1,
			"bathroom": "1st Floor near SLC"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/chemistrybuilding.json
// module id = 847
// module chunks = 0